// Provider color palette per spec v2 lines 158-172. 11 providers total.
// Search-off variants reuse the same hex with `faded: true` (rendered at 50% opacity).
export const PROVIDER_COLORS = {
  'ChatGPT (search on)':    { hex: '#10A37F', faded: false },
  'ChatGPT (search off)':   { hex: '#10A37F', faded: true  },
  'Claude (search on)':     { hex: '#D4A574', faded: false },
  'Claude (search off)':    { hex: '#D4A574', faded: true  },
  'Perplexity':             { hex: '#20808D', faded: false },
  'Gemini (search on)':     { hex: '#4285F4', faded: false },
  'Gemini (search off)':    { hex: '#4285F4', faded: true  },
  'Grok':                   { hex: '#1DA1F2', faded: false },
  'Google Organic':         { hex: '#EA4335', faded: false },
  'Google AI Overviews':    { hex: '#FBBC04', faded: false },
  'Google AI Mode':         { hex: '#34A853', faded: false },
};

const FALLBACK = { hex: '#6B7280', faded: false };

export function colorFor(displayName) {
  if (!displayName) return FALLBACK;
  if (PROVIDER_COLORS[displayName]) return PROVIDER_COLORS[displayName];
  const key = Object.keys(PROVIDER_COLORS).find(k => k.toLowerCase() === String(displayName).toLowerCase());
  return key ? PROVIDER_COLORS[key] : FALLBACK;
}

// Display polish for provider labels coming off the backend `display_name`
// field. Backend ships "Claude (search on)" with a lowercase "search"; product
// (markup #108 follow-up) wants "Claude (Search on)" in customer-facing copy.
// We keep the canonical lookup keys lowercase so colorFor still resolves them
// case-insensitively, but the rendered label gets a title-cased "Search".
export function prettifyProviderLabel(name) {
  if (name == null) return '';
  return String(name)
    .replace(/\(search on\)/gi, '(Search on)')
    .replace(/\(search off\)/gi, '(Search off)');
}
